<template>
  <v-expansion-panel-header 
    :hide-actions="hideArrow" 
    style="border-radius:0;"
    :style="{ 'font-family': FontSecundary, 'font-size': `${FontSizeSecundary}px` }"
  >
  <center
    v-if="hideArrow"
    style="font-size: 12px"
    :style="{ 'text-transform': '' }"
    >{{ text }}</center>
  <span v-else 
    :style="{ 'text-transform': format === 1 ? 'uppercase' : null }"
  > 
    {{ text }}
  </span>
  </v-expansion-panel-header>
</template>
<script>
  import { mapState } from 'vuex'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        default: null
      },
      format: {
        type: Number,
        default: null
      },
      hideArrow: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      text: null,
    }),
    computed:{
      ...mapState('app',['locale', 'FontSecundary', 'FontSizeSecundary', ]),
    },
    watch: {
      locale() {
        this.prepareText()
      }
    },
    mounted () {
      this.prepareText()
    },
    methods: {
      prepareText () {
        this.text = this.data ? utils.getTranslation(this.data, this.locale) : ''
      }
    }
  }
</script>
